import React from 'react';
import { Box, Text, SimpleGrid, VStack, Image, Button, Badge } from '@chakra-ui/react';
interface ProductCardProps {
  name: string;
  price: string;
  imageUrl: string;
  badge?: string;
}
function ProductCard({
  name,
  price,
  imageUrl,
  badge
}: ProductCardProps) {
  return <Box className="product-card" borderRadius="12px" overflow="hidden" bg="white" data-id="element-50">
      {/* Product image */}
      <Box position="relative" aspectRatio="1/1" bg="#F0F0F0" overflow="hidden" data-id="element-51">
        <Image src={imageUrl} alt={name} w="100%" h="100%" objectFit="cover" fallback={<Box w="100%" h="100%" bg="linear-gradient(135deg, #FAE0E4 0%, #F5EDE0 50%, #FAE0E4 100%)" display="flex" alignItems="center" justifyContent="center" data-id="element-53">
              <Text className="font-script" fontSize="22px" color="#C9929D" opacity={0.5} textAlign="center" px={4} data-id="element-54">
                {name}
              </Text>
            </Box>} data-id="element-52" />
        {badge && <Badge position="absolute" top={3} left={3} bg="#C9929D" color="white" fontSize="10px" fontWeight={600} px={2} py={1} borderRadius="6px" className="font-body" letterSpacing="0.04em" data-id="element-55">
            {badge}
          </Badge>}
      </Box>

      {/* Product info */}
      <Box p={4} data-id="element-56">
        <Text className="font-body" fontSize="15px" fontWeight={500} color="#3A3A3A" mb={1} noOfLines={2} data-id="element-57">
          {name}
        </Text>
        <Text className="font-serif" fontSize="16px" fontWeight={600} color="#C9929D" data-id="element-58">
          {price}
        </Text>
      </Box>
    </Box>;
}
export function FeaturedProducts() {
  return <Box as="section" bg="#FFF5F6" py={{
    base: 16,
    md: 20
  }} px={{
    base: 6,
    md: 12,
    lg: 20
  }} data-id="element-59">
      <VStack spacing={12} maxW="1200px" mx="auto" data-id="element-60">
        {/* Section title */}
        <VStack spacing={3} textAlign="center" data-id="element-61">
          <Text className="font-script" fontSize={{
          base: '20px',
          md: '24px'
        }} color="#C9929D" data-id="element-62">
            just dropped
          </Text>
          <Text as="h2" className="font-serif" fontSize={{
          base: '28px',
          md: '36px'
        }} fontWeight={700} color="#3A3A3A" data-id="element-63">
            New Arrivals
          </Text>
          <Box w="60px" h="2px" bg="#F4B8C1" borderRadius="full" data-id="element-64" />
        </VStack>

        {/* Product grid */}
        <SimpleGrid columns={{
        base: 1,
        sm: 2,
        lg: 4
      }} spacing={{
        base: 6,
        md: 6
      }} w="100%" data-id="element-65">
          <ProductCard name="Vintage Floral Midi Dress" price="$38.00" imageUrl="https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=500&q=80" badge="One-of-a-Kind" data-id="element-66" />
          <ProductCard name="The Fringe Western Jacket" price="$52.00" imageUrl="https://cdn.magicpatterns.com/uploads/2tX41HEK6FsN8buzVpLyVZ/omar-lopez-buA5_3PDBXw-unsplash.jpg" badge="One-of-a-Kind" data-id="element-67" />
          <ProductCard name="Lace Trim Blouse" price="$29.00" imageUrl="https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&q=80" badge="One-of-a-Kind" data-id="element-68" />
          <ProductCard name="Boho Maxi Skirt" price="$44.00" imageUrl="https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=500&q=80" badge="One-of-a-Kind" data-id="element-69" />
        </SimpleGrid>

        {/* View all CTA */}
        <Button variant="outline" borderColor="#C9929D" color="#C9929D" fontSize="15px" fontWeight={600} px={10} h="48px" borderRadius="24px" className="font-body" _hover={{
        bg: '#C9929D',
        color: 'white',
        transform: 'translateY(-2px)'
      }} transition="all 0.25s" w={{
        base: '100%',
        sm: 'auto'
      }} data-id="element-70">
          View All Products
        </Button>
      </VStack>
    </Box>;
}